import { StudyState } from '@app/types'
import { PeerReviewStatus } from '../types/peerReview.type'
import { StudyDesignStatus } from '../types/studyDesignStatus.type'
import { Attribute } from './attributes.model'
import { FileMeta } from './file-meta.model'
import { ReviewItem } from './reviewItem.model'
import { ArticleMetadata } from './reviewItemMetadata/articleMetadata'
import { Search } from './search.model'
import { StudyDesign } from './studyDesign.model'
import { INCLUDED } from '../types/included-screening-criterion.type'
import { ReviewItemType } from '../types/reviewItemType.type'

export class Article extends ReviewItem {
  metadata: ArticleMetadata
  constructor({
    complaintDate,
    reviewId,
    search,
    appraisal,
    fullTextScreening,
    id,
    isFavorite,
    maybeParentStudyId,
    oxfordLevelOfEvidence,
    parentStudyId,
    pdfFile,
    peerReviewStatus,
    synthesis,
    titleAndAbstractScreening,
    studyDesign,
    studyDesignStatus,
    metadata,
  }: {
    complaintDate?: Date
    reviewId: number
    search: Search
    appraisal?: { [key: string]: string }
    fullTextScreening?: string
    id: number
    isFavorite?: boolean
    maybeParentStudyId?: number
    oxfordLevelOfEvidence?: string
    parentStudyId?: number
    pdfFile?: FileMeta
    peerReviewStatus?: PeerReviewStatus
    synthesis?: { attributes: Attribute[] }
    titleAndAbstractScreening?: string
    studyDesign?: StudyDesign
    studyDesignStatus?: StudyDesignStatus
    metadata?: ArticleMetadata
  }) {
    super({
      complaintDate,
      reviewId,
      search,
      appraisal,
      fullTextScreening,
      id,
      isFavorite,
      maybeParentStudyId,
      oxfordLevelOfEvidence,
      parentStudyId,
      pdfFile,
      peerReviewStatus,
      synthesis,
      titleAndAbstractScreening,
      studyDesign,
      studyDesignStatus,
    })
    this.metadata = new ArticleMetadata(metadata ?? {})
    this.type = ReviewItemType.Article
  }

  get DoiLink() {
    return this.metadata.doi ? `https://doi.org/${this.metadata.doi}` : ''
  }

  get state(): StudyState {
    if (this.isDuplicate) return StudyState.DUPLICATE
    if (this.fullTextScreening === INCLUDED) return StudyState.INCLUDED
    if (
      (this.titleAndAbstractScreening &&
        this.titleAndAbstractScreening != INCLUDED) ||
      (this.fullTextScreening && this.fullTextScreening !== INCLUDED)
    )
      return StudyState.EXCLUDED
    if (
      !this.metadata.abstract ||
      !this.metadata.title ||
      this.metadata.abstract.startsWith('...') ||
      this.metadata.abstract.endsWith('...') ||
      this.metadata.abstract.toLowerCase() === 'n/a' ||
      this.maybeDuplicate ||
      !this.metadata?.publishYear ||
      (this.metadata?.authors?.length ?? 0) === 0
    )
      return StudyState.QUARANTINED
    return StudyState.UNSCREENED
  }
}
